import { Middleware } from "../Middleware";
import { MiddlewareInterface } from "../MiddlewareInterface";
import { EventInterface } from "../../Entity/Entities/Event/EventInterface";
import Constants from "../../Action/Constants";

class EventUpdateWillMount extends Middleware implements MiddlewareInterface {

  public component: any;

  constructor() {
    super();
  }

  public process(): void {
    this.component.session = this.component.props.app.session.user;
    this.component.person = this.component.props.app.persons.filter(
      person => person.id === this.component.session.id
    )[0];
    this.component.props.dispatch({
      type: Constants.GLOBAL_EVENT_UPDATE_CLEAR
    });
    
    this.component.props.dispatch({
      type: Constants.GLOBAL_EVENT_UPDATE_CLEAR
    });

    const id: number = parseInt(this.component.props.params.id, 10);

    this.component.props.dispatch({
      type: Constants.GLOBAL_EVENT_FOR_EVENT_DETAILS_PAGE,
      payload: {
        eventId: id
      },
      onSuccess: (event: EventInterface) => {
        if (!event) {
          return this.component.redirectBack();
        }
        this.component.initializePage(event);
        this.component.fetchEntityEvents(id, false);
      },
      onError: err => {
        console.log(err)
      },
    })
  }
}

export default new EventUpdateWillMount();
